import React from 'react'
import yup from 'yup'
import Form from 'react-formal'
import { Checkbox } from 'react-icheck'
import { getToken } from '../Commons/Authentication'
import { hashHistory } from 'react-router'
import _ from 'lodash'
import * as request from 'superagent'
import NoCache from 'superagent-no-cache'
import { ToastContainer, ToastMessage } from 'react-toastr'

const ToastMessageFactory = React.createFactory(ToastMessage.animation)

var epsSchema = yup.object({
  nombre: yup.string().min(2, 'El nombre debe tener mínimo 2 caracteres').required('Ingrese el nombre completo')
})

export default class EpsForm extends React.Component {
  constructor (props) {
    super(props)
    this.state = ({ model: {}, isCheckedStatus: false, dirty: false })
  }
  toggleChangeStatus () {
    this.setState({
      isCheckedStatus: !this.state.isCheckedStatus, dirty: true // flip boolean value
    })
  }
  cancelFunction (e) {
    hashHistory.push('searchEps/')
  }
  saveEps (e) {
    if (this.props.isUpdate) {
      console.log('updatate')
      let eps = this.state.model
      eps.status = this.state.isCheckedStatus
      let url = 'api/v1/eps/'
      request
      .put(url)
      .use(NoCache)
      .set('Authorization', 'Bearer ' + getToken())
      .send(eps)
      .end((err, res) => {
        if (err) {
          this.refs.container.error('Algo inesperado paso y no se pudo guardar la información', '', {
            closeButton: true
          })
        } else {
          this.refs.container.success('Los datos se guardaron correctamente', 'Actualizada', {
            closeButton: true
          })
          setTimeout(() => { hashHistory.push('searchEps/') }, 2800)
        }
      })
    } else {
      let eps = this.state.model
      eps.status = this.state.isCheckedStatus
      let url = 'api/v1/eps/register'
      request
      .post(url)
      .use(NoCache)
      .set('Authorization', 'Bearer ' + getToken())
      .send(eps)
      .end((err, res) => {
        if (err) {
          this.refs.container.error('Algo inesperado paso y no se pudo guardar la información', '', {
            closeButton: true
          })
        } else {
          this.refs.container.success('Los datos se guardaron correctamente', 'Guardada', {
            closeButton: true
          })
          setTimeout(() => { hashHistory.push('searchEps/') }, 2800)
        }
      })
    }
  }
  componentWillMount () {
    if (!_.isEmpty(this.props.epsName)) {
      let endpoint = '/api/v1/eps/find/'
      let query = {nombre: this.props.epsName}
      request
      .get(endpoint)
      .use(NoCache)
      .set('Authorization', 'Bearer ' + getToken())
      .query(query)
      .end((err, res) => {
        if (err) {
          this.refs.container.error('Algo inesperado paso y no se pudo cargar la información', '', {
            closeButton: true
          })
        } else {
          console.log(res.body[0])
          this.setState({'model': res.body[0], 'isCheckedStatus': res.body[0]['status']})
        }
      })
    }
  }

  render () {
    return (
      <Form className='form-eps-info' schema={epsSchema} value={this.state.model} onChange={model => this.setState({ model, dirty: true })}>
        <div className='eps-info-container'>
        <ToastContainer toastMessageFactory={ToastMessageFactory} ref='container' className='toast-top-right' />
          <div className='eps-data-fields eps-left-container'>
            <div className='form-group'>
              <Form.Field name='nombre' id='nombre' ref='nombre' className='form-input' placeholder='Nombre Eps'/>
              <Form.Message className='message' for='nombre'/>
            </div>
            <div className='form-group'>
              <div className='check-input'>
              <Checkbox ref='status' checkboxClass='icheckbox_square-blue' checked={this.state.isCheckedStatus} onChange={this.toggleChangeStatus.bind(this)} increaseArea='16%' label='Estado' />
              </div>
            </div>
          </div>
        </div>
        <div className='form-submit-btn-container'>
          <button id='cancelSquares' className='form-submit-button save-button' onClick={this.cancelFunction.bind(this)}>⟵ Regresar</button>
          <Form.Button type='submit' id='saveData' className='form-submit-button save-button' onClick={this.saveEps.bind(this)}>Guardar</Form.Button>
        </div>
      </Form>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/EPS/EpsForm.js